import React, { useState } from "react";
import UserProfile from "./UserProfile";
import ChatScreen from "./chatscreen";

const ChatWindow = ({ chat, isOnline, onChatUpdate, onChatCleared }) => {
  const [showProfile, setShowProfile] = useState(false);
  const [sharedMedia, setSharedMedia] = useState([]);

  return (
    <div className="flex-1 min-w-0 rounded-2xl border border-[#00000040] bg-white">
      {showProfile && (
        <div className="p-3">
          <UserProfile
            chat={chat}
            sharedMedia={sharedMedia}
            onBack={() => setShowProfile(false)}
            onChatUpdate={onChatUpdate}
            onChatCleared={onChatCleared}
          />
        </div>
      )}
      {/* Kept mounted while the profile is open so the conversation is not reloaded */}
      <div className={showProfile ? "hidden" : ""}>
        <ChatScreen
          chat={chat}
          isOnline={isOnline}
          onNameClick={() => setShowProfile(true)}
          onMediaChange={setSharedMedia}
          onChatUpdate={onChatUpdate}
        />
      </div>
    </div>
  );
};

export default ChatWindow;
